import UserDetailsForm from './UserDetailsForm';

export default UserDetailsForm;
